import Component from 'inferno-component';
import { Grid, Image } from 'semantic-ui-react';

export class Partner extends Component {
  render() {
    return (
      <Grid.Column
        mobile={8}
        tablet={5}
        computer={2}
        style={{backgroundColor: 'white', margin: '0.5rem', alignItems: 'center', display: 'flex'}}
        >
          <Image src={this.props.partner.logo} style={{maxHeight: '6rem', margin: 'auto'}}/>
      </Grid.Column>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partners/Partner.js